module.exports = __webpack_public_path__ + "img/Desk Stationary A11.4c1ac358.jpg";